import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const AbsenceCategorizationAccordion = ({ formData, updateField }) => {
  const { t } = useTranslation();
  const unitLabel = formData.unit === 'DAY' ? t('common.days') : t('common.hours');

  return (
  <AccordionItem value="categorization">
    <AccordionTrigger>
      <div className="flex items-center gap-2">
        <Shield className="h-5 w-5" />
        {t('absenceReasons.form.categorizationTitle')}
      </div>
    </AccordionTrigger>
    <AccordionContent className="space-y-4 pt-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="is_justified"
            checked={formData.is_justified}
            onCheckedChange={(checked) => updateField('is_justified', checked)}
          />
          <Label htmlFor="is_justified" className="cursor-pointer">{t('absenceReasons.form.justified')}</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="is_planned"
            checked={formData.is_planned}
            onCheckedChange={(checked) => updateField('is_planned', checked)}
          />
          <Label htmlFor="is_planned" className="cursor-pointer">{t('absenceReasons.form.planned')}</Label>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="unit">{t('absenceReasons.form.unit')}</Label>
        <Select value={formData.unit} onValueChange={(v) => updateField('unit', v)}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="DAY">{t('absenceReasons.form.day')}</SelectItem>
            <SelectItem value="HOUR">{t('absenceReasons.form.hour')}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="requires_approval"
          checked={formData.requires_approval}
          onCheckedChange={(checked) => updateField('requires_approval', checked)}
        />
        <Label htmlFor="requires_approval" className="cursor-pointer">{t('absenceReasons.form.requiresApproval')}</Label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="requires_justification"
          checked={formData.requires_justification}
          onCheckedChange={(checked) => updateField('requires_justification', checked)}
        />
        <Label htmlFor="requires_justification" className="cursor-pointer">
          {t('absenceReasons.form.requiresJustification')}
        </Label>
      </div>

      {formData.requires_justification && (
        <div className="flex items-center space-x-2">
          <Checkbox
            id="justification_mandatory"
            checked={formData.justification_mandatory}
            onCheckedChange={(checked) => updateField('justification_mandatory', checked)}
          />
          <Label htmlFor="justification_mandatory" className="cursor-pointer">
            {t('absenceReasons.form.justificationMandatory')}
          </Label>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="advance_notice_days">{t('absenceReasons.form.advanceNotice')}</Label>
          <Input
            id="advance_notice_days"
            type="number"
            min="0"
            value={formData.advance_notice_days}
            onChange={(e) => updateField('advance_notice_days', parseInt(e.target.value))}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="max_duration_without_document">
            {t('absenceReasons.form.maxDurationWithoutDocument', { unit: unitLabel })}
          </Label>
          <Input
            id="max_duration_without_document"
            type="number"
            min="0"
            value={formData.max_duration_without_document || ''}
            onChange={(e) =>
              updateField('max_duration_without_document', e.target.value ? parseInt(e.target.value) : null)
            }
            placeholder={t('absenceReasons.form.unlimited')}
          />
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="blocks_attendance"
          checked={formData.blocks_attendance}
          onCheckedChange={(checked) => updateField('blocks_attendance', checked)}
        />
        <Label htmlFor="blocks_attendance" className="cursor-pointer">{t('absenceReasons.form.blocksAttendance')}</Label>
      </div>
    </AccordionContent>
  </AccordionItem>
  );
};

export default AbsenceCategorizationAccordion;
